module.exports = __webpack_public_path__ + "img/cs.52ca9f49.png";